import { StatusPill as DsStatusPill, type StatusTone } from '@/components/ui/status-pill'
import type { LineStatus } from '@/lib/operator-status'

/**
 * Vision → operator vocabulary. Wire tokens stay UPPER_SNAKE; labels are local.
 *
 * `REJECTED` is Pulse-local (see {@link LineStatus}) and only a line ever carries it,
 * so it stays out of `FILTER_ORDER_STATUSES` — the queue's Status filter posts wire
 * tokens to Vision and has nothing to ask for.
 */
export const STATUS_LABEL: Record<LineStatus, string> = {
  RECEIVED: 'Received',
  VALIDATION_FAILED: 'Validation failed',
  READY_TO_ACKNOWLEDGE: 'Ready to acknowledge',
  ACKNOWLEDGING: 'Acknowledging',
  ACKNOWLEDGED: 'Ackd',
  PARTIALLY_ACKED: 'Partially acked',
  FULLY_ACKED: 'Ackd',
  PARTIALLY_CANCELLED: 'Partially cancelled',
  PARTIALLY_FULFILLED: 'Partially fulfilled',
  FULFILLED: 'Fulfilled',
  CANCELLED: 'Cancelled',
  CLOSED: 'Closed',
  REJECTED: 'Rejected',
}

const STATUS_TONE: Record<LineStatus, StatusTone> = {
  RECEIVED: 'mute',
  VALIDATION_FAILED: 'crit',
  READY_TO_ACKNOWLEDGE: 'warn',
  ACKNOWLEDGING: 'warn',
  ACKNOWLEDGED: 'ok',
  PARTIALLY_ACKED: 'warn',
  FULLY_ACKED: 'ok',
  PARTIALLY_CANCELLED: 'warn',
  PARTIALLY_FULFILLED: 'warn',
  FULFILLED: 'ok',
  CANCELLED: 'crit',
  CLOSED: 'mute',
  REJECTED: 'crit',
}

export function StatusPill({ status }: { status: LineStatus }) {
  return (
    <DsStatusPill tone={STATUS_TONE[status] ?? 'mute'}>
      {STATUS_LABEL[status] ?? status}
    </DsStatusPill>
  )
}
